<!--
  Generated template for the TextCookiesPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-header>
	<ion-toolbar class="shadow">
      <ion-buttons slot="start" *ngIf="previousUrl">
        <ion-back-button [defaultHref]="previousUrl" (click)="navCtrl.back()"></ion-back-button>
      </ion-buttons>
      <ion-title>
        <!-- <div style="padding-top:15px;padding-bottom:15px;"> -->
          {{ 'SETTINGS_COOKIES_BTN' | translate}}
		<!-- </div> -->
      </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content padding>
	<!-- <h2>Cookies</h2> -->

	<p>
		<b>Was sind Cookies und andere Technologien?</b> <br />
		Ein Cookie ist eine kleine Textdatei, die auf Ihrem Computer, Ihrem Mobiltelefon oder einem anderen Gerät
		platziert wird, wenn Sie eine Webseite besuchen. Das Cookie hilft den Betreibern der Webseite dabei, Ihr Gerät
		bei Ihrem nächsten Besuch der Seite zu erkennen. Es gibt andere, ähnliche Technologien wie Pixel-Tags
		(transparente grafische Bilder, die auf einer Webseite oder in einer E-Mail platziert werden und anzeigen, dass
		die Webseite oder die E-Mail gesehen wurde), Web-Bugs (ähnlich Pixel-Tags) und Webspeicher, die für
		Desktop-Software oder Mobilgeräte eingesetzt werden.
		Daneben gibt es Technologien wie Mobilfunk-Identifier und SDK-Integrationen, die Unternehmen das Erkennen Ihres
		Geräts ermöglichen, wenn Sie die App wieder nutzen oder einen Dienst erneut aufrufen.
	</p>
	<p>
		<b>Verwaltung Ihrer Cookies und anderer Präferenzen</b> <br />
		Viele Internet-Browser erlauben Ihnen die Einstellung Ihrer Präferenzen. Sie können den Browser so einstellen,
		dass Cookies abgelehnt oder bestimmte Cookies gelöscht werden.
		Sie können eventuell auch andere Technologien auf dieselbe Weise, in der Sie Cookies verwalten, mithilfe der
		Einstellungen Ihres Browsers kontrollieren.
	</p>
	<p>
		Beachten Sie, dass das (IT)&#x000B2; interactive GmbH nach dem Blockieren der Cookies eventuell eingeschränkt
		sind oder bestimmte Elemente nicht funktionieren.
	</p>
	<p>
		Es gibt keinen akzeptierten Standard zum Umgang mit „Do-Not-Track“-Signalen und wir reagieren nicht auf solche
		Signale. Wir nutzen das AdChoices-Symbol auf unserer Webseite und es kann auch bei bestimmten, zielgerichteten
		Anzeigen, die Sie von uns (oder von einem Dienstleister in unserem Namen) auf der Basis der Informationen über
		Ihre Online-Aktivitäten erhalten. Sie können auf das AdChoices-Symbol klicken oder <a
			href="http://aboutads.info" target="_blank">aboutads.info</a> besuchen, um weitere Informationen über die
		Erfassung und Nutzung der Daten zu Ihrer Online-Aktivität zur verhaltensgesteuerten Online-Werbung zu erhalten,
		oder um zu erfahren, wie Sie die Nutzung Ihrer Daten für verhaltensgesteuerte Werbung durch die Mitglieder der
		Digital Advertising Alliance (DAA) unterbinden können.
		Kanadische Nutzer können auch <a href="http://youradchoices.ca" target="_blank">youradchoices.ca</a> besuchen.
		Europäische Nutzer können <a href="http://youronlinechoices.com" target="_blank">youronlinechoices.com</a>
		besuchen und erfahren dort, wie sie die Nutzung Ihrer Daten für verhaltensgesteuerte Werbung durch
		Mitgliedsunternehmen der Europäische Allianz für Werbeselbstkontrolle (EASA) unterbinden können.
	</p>
	<p>
		Ein weiteres, Ihnen zur Verfügung stehendes Tool ist das Opt-Out-Tool der Network Advertising Initiative (NAI)
		unter <a href="http://networkadvertising.org/choices" target="_blank">networkadvertising.org/choices</a>. Damit
		können Sie die Nutzung der Daten zu Ihrer Online-Aktivität zum Zweck verhaltensgesteuerter Werbung durch ein
		NAI-Mitglied sperren.
		Ihr Mobilgerät verfügt über die Einstellung „Limit Ad Tracking“ (iOS-Geräte) oder „Opt-out of Interest-Based
		Ads“ (Android), die Ihnen ermöglichen, die Informationen zu Ihrer Nutzung von Apps zum Zweck zielgerichteter
		Werbung zu unterbinden.
		Beachten Sie, dass Sie auch nach der Nutzung der oben beschriebenen Sperren auch weiterhin Anzeigen erhalten,
		wenn Sie die (IT)&#x000B2; interactive GmbH nutzen.
		Wir arbeiten mit Werbepartnern zur Bereitstellung von Anzeigen. Eine von uns zur Verfolgung der Aktivität in
		Bezug auf die Dienste genutzte Dienstleistung, z. B. durch die Platzierung von Cookies,
		ist Google Analytics von Google (Google Inc., ein Unternehmen mit Sitz in 1600 Amphitheatre Parkway, Mountain
		View, CA 94043, USA). Wir können Anbieter, einschließlich Google, damit beauftragen, Erstanbieter-Cookies (wie
		das Google Analytics-Cookie) und Drittanbieter-Cookies (wie das DoubleClick-Cookie) zusammen zu platzieren,
		um zu informieren, zu optimieren und Anzeigen zu platzieren, die auf früheren Besuchen unserer Webseiten
		basieren, darunter Google Analytics für Display Advertising. Google stellt Tools zur Verwaltung der Erfassung
		und Nutzung bestimmter Informationen durch Google Analytics
		unter <a href="http://tools.google.com/dlpage/gaoptout" target="_blank">tools.google.com/dlpage/gaoptout</a> und
		durch Google Analytics für Display Advertising oder das Google Display Network mithilfe der Einstellungen für
		Google-Anzeigen unter <a href="http://google.com/settings/ads" target="_blank">google.com/settings/ads</a> zur
		Verfügung.
		Sie stimmen hiermit der Nutzung von Cookies und anderen Technologien wie oben beschrieben zu.
	</p>

</ion-content>